<template>
  <div
    class="d-flex flex-column align-items-center justify-content-center text-white p-lg text-center"
    :class="`bg-${color}`">
    <slot name="icon"/>
    <b v-if="title">
      {{ title }}
    </b>
    <p
      v-if="description"
      class="small-text text-white">
      {{ description }}
    </p>
    <slot name="button"/>
  </div>
</template>
<script setup>

defineProps({
  title: {
    type: String,
    required: false,
    default: ''
  },
  description: {
    type: String,
    required: false,
    default: ''
  },
  color: {
    type: String,
    required: false,
    default: 'plum'
  }
})
</script>
